import { ForiegnPassPort } from './ForeignPass';
import { ForeignID } from './ForeignID';

export { ID } from './ID';
export { DriverLicense } from './DriverLicense';
export { PassPort } from './PassPort';

export const Foreign = { PassPort: ForiegnPassPort, ID: ForeignID };
